// Rows per page on the Excalibur, Filing and Transaction Details tables; the backend keeps sending
// up to 100 rows per call and the browser slices what it has loaded into pages of this size.
export const TABLE_PAGE_SIZE = 25;

// Page numbers the pager shows at once, starting at the current page.
export const PAGE_WINDOW_SIZE = 3;

/** The slice of `rows` shown on 1-based `pageIndex`; empty when that page is not loaded. */
export function getPageItems(rows, pageIndex, pageSize = TABLE_PAGE_SIZE) {
    if (!Array.isArray(rows)) {
        return [];
    }
    const start = (pageIndex - 1) * pageSize;
    return rows.slice(start, start + pageSize);
}

/** Number of pages the loaded rows fill (at least 1, so the pager always has a page to stand on). */
export function getLoadedPageCount(rows, pageSize = TABLE_PAGE_SIZE) {
    const length = Array.isArray(rows) ? rows.length : 0;
    return Math.max(1, Math.ceil(length / pageSize));
}

/** Page numbers to show: up to `windowSize` consecutive numbers from the current page, never past `pagesCount`. */
export function getPageWindow(currentPageIndex, pagesCount, windowSize = PAGE_WINDOW_SIZE) {
    const first = Math.max(1, currentPageIndex);
    const last = Math.min(Math.max(first, pagesCount), first + windowSize - 1);
    const pages = [];
    for (let page = first; page <= last; page++) {
        pages.push(page);
    }
    return pages;
}

/** True while the window from the current page would run past the loaded pages and the backend still has rows. */
export function needsMoreRows(currentPageIndex, pagesCount, hasMore, windowSize = PAGE_WINDOW_SIZE) {
    return Boolean(hasMore) && pagesCount < currentPageIndex + windowSize - 1;
}

/** `rows` followed by the `incoming` rows whose `key` was not seen yet, so a page returned twice adds nothing. */
export function mergeRows(rows, incoming, key) {
    const current = Array.isArray(rows) ? rows : [];
    if (!Array.isArray(incoming) || incoming.length === 0) {
        return current;
    }
    const seen = new Set(current.map(row => row?.[key]).filter(value => value != null));
    const merged = current.slice();
    incoming.forEach(row => {
        const value = row?.[key];
        if (value == null) {
            merged.push(row);
            return;
        }
        if (!seen.has(value)) {
            seen.add(value);
            merged.push(row);
        }
    });
    return merged;
}
